import React from 'react';

import './FooterOverlay.css';

const FooterOverlay = () => (
  <div className = "app__footerOverlay">
    <div className = "app__footerOverlay-black"/>
    <div className = "app__footerOverlay-img"/>
  </div>
);

export default FooterOverlay;
